export const ANALYTICS_CONSENT_KEY = 'belgium-in-maps.analytics-consent'
// The provider set now includes GA4. Existing Clarity-only grants must not
// silently authorize a newly introduced analytics provider.
export const ANALYTICS_CONSENT_VERSION = '2026-08-13'
export const ANALYTICS_CONSENT_MAX_AGE_MS = 183 * 24 * 60 * 60 * 1000

export type AnalyticsDecision = 'granted' | 'denied'

export interface StoredAnalyticsConsent {
  version: string
  decision: AnalyticsDecision
  decidedAt: string
}

export function readAnalyticsConsent(now = Date.now()): StoredAnalyticsConsent | null {
  try {
    const parsed = JSON.parse(localStorage.getItem(ANALYTICS_CONSENT_KEY) ?? 'null') as Partial<StoredAnalyticsConsent> | null
    if (
      !parsed
      || parsed.version !== ANALYTICS_CONSENT_VERSION
      || (parsed.decision !== 'granted' && parsed.decision !== 'denied')
      || typeof parsed.decidedAt !== 'string'
    ) return null
    const decidedAt = Date.parse(parsed.decidedAt)
    if (!Number.isFinite(decidedAt) || decidedAt > now || now - decidedAt > ANALYTICS_CONSENT_MAX_AGE_MS) return null
    return parsed as StoredAnalyticsConsent
  } catch {
    return null
  }
}

export function storeAnalyticsConsent(decision: AnalyticsDecision, now = new Date()): StoredAnalyticsConsent {
  const consent: StoredAnalyticsConsent = {
    version: ANALYTICS_CONSENT_VERSION,
    decision,
    decidedAt: now.toISOString(),
  }
  try {
    localStorage.setItem(ANALYTICS_CONSENT_KEY, JSON.stringify(consent))
  } catch {
    // Storage can be unavailable in private browsing. Consent remains scoped to
    // this page and analytics will not be loaded again on the next page view.
  }
  return consent
}
